<template>
  <div>
    <Nav />
  </div>
</template>
<script>
import Nav from '@/v2/auto/sections/0-top_nav.vue'
export default {
  components: {
    Nav,
  },
}
</script>
